const state = {
  menuItemBubble: { // rename to childBubble
    distanceToCenter: 0.5,
    size: 0.15,
    maxSize: 110, // Max size in px
    classes: []
  },
  menuMainBubble: { // rename to parentBubble
    size: 0.5, // Size in percent of relative parent
    classes: []
  },
  app: {
    router: null, // {}
    initialRoute: null, // {}
    containerSize: 0,
    itemsPerPage: 10,
    showActions: false,
    draggableBubbles: false
  },
  breadcrumb: {
    enabled: true,
    showHomeItem: true,
    colors: ['darkgrey', 'lightgrey'],
    homeLabel: 'Home',
    item: {
      size: 25,
      classes: [],
      activeClasses: []
    }
  },
  pagination: {
    enabled: false,
    buttonSize: 0.04, // Size in percent of app container
    buttonPrev: {
      title: 'Previous',
      classes: []
    },
    buttonNext: {
      title: 'Next',
      classes: []
    }
  },
  backButton: {
    size: 0.05,
    title: 'Previous',
    classes: []
  }
}

export default state
